import { IErpTask } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ErpTaskChannel } from 'src/app/business/erpTask/contracts/erp-task-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { ErpTaskModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class ErpTaskSyncService extends SyncService<IErpTask> {
  protected limit = 100;

  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IErpTask>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(ErpTaskModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return channel === ErpTaskChannel.CREATE || channel === ErpTaskChannel.EDIT || channel === ErpTaskChannel.DELETE;
  }
}
